import React from 'react';
import styled from 'styled-components';
import logo from '../assets/images/farmstream_logo.png';

interface State {
  hasError: boolean;
}

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  handleReload = () => {
    window.location.href = '/';
  };

  render() {
    if (this.state.hasError) {
      return (
        <Container>
          <Wrapper>
            <Logo src={logo} alt="Farmstream logo" />
            <h1>Something went wrong</h1>
            <p>An unexpected error occurred. Please try again.</p>
            <ReloadButton onClick={this.handleReload}>Back to Home</ReloadButton>
          </Wrapper>
        </Container>
      );
    }

    return this.props.children;
  }
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;
  width: 100%;
  background-color: #f5f5f5;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
`;

const Logo = styled.img`
  width: 100px;
`;

const ReloadButton = styled.button`
  color: white;
  background-color: ${({ theme }) => theme.colors.primary};
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  font-size: 0.9rem;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
